import { apiRequest } from '../../shared/api/base'

interface OwnEmailsResponse {
  ownEmails: string[]
}

export async function getOwnEmails(): Promise<string[]> {
  const res = await apiRequest<OwnEmailsResponse>('/settings/own-emails')
  return res.ownEmails
}

export async function addOwnEmail(email: string): Promise<string[]> {
  const res = await apiRequest<OwnEmailsResponse>('/settings/own-emails', {
    method: 'POST',
    body: JSON.stringify({ email }),
  })
  return res.ownEmails
}

export async function removeOwnEmail(email: string): Promise<string[]> {
  const res = await apiRequest<OwnEmailsResponse>(
    `/settings/own-emails/${encodeURIComponent(email)}`,
    { method: 'DELETE' },
  )
  return res.ownEmails
}
